module.exports = __webpack_public_path__ + "img/yiyuan.8f1e7128.jpg";